/* eslint-disable react/prop-types */
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import theme from "assets/theme";
import { useEffect, useRef, useState } from "react";
import { PaperComponent } from "../../utils/constants";

const PrintHoSoDangKy = ({ data, open, onClose }) => {
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const toolBarRef = useRef(null);
  const [printContent, setPrintContent] = useState("");
  useEffect(() => {
    let body = "";
    if (data && data.id) {
      body = `<figure class="table">
  <table>
  <tbody>
  <tr>
  <td>
  <p style="text-align:justify;"><strong>ỦY BAN NHÂN DÂN&nbsp;</strong></p>
  <p style="text-align:justify;"><strong>${data?.maphuong_ten
    ?.toString()
    ?.toUpperCase()}</strong></p></td>
  <td>&nbsp;</td>
  <td>&nbsp;</td>
  <td>&nbsp;</td>
  <td>&nbsp;</td>
  <td>
  <p style="text-align:center;"><strong>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</strong></p>
  <p style="text-align:center;"><u>Độc lập – Tự do – Hạnh phúc</u></p>
  </td>
  </tr>
  </tbody>
  </table>
  </figure>
  <p>&nbsp;</p><p style="text-align:center;"><strong>BÁO CÁO</strong></p>
  <p style="text-align:center;"><strong>Về việc đánh giá một số nội dung của Hồ sơ sản phẩm đăng ký tham gia đánh giá sản phẩm OCOP</strong></p>
  <p><strong>I. THÔNG TIN CHUNG VỀ HỒ SƠ ĐĂNG KÝ</strong></p>
  <p>1. Tên&nbsp;chủ&nbsp;thể:&nbsp;${data?.chuthe_ten}</p>
  <p>2. Loại hình tổ chức:&nbsp;${
    data?.loaihinhtochuc ? data?.loaihinhtochuc : ""
  }</p>
  <p>3. Địa chỉ:&nbsp;${data?.chuthe_diachi ? data?.chuthe_diachi : ""}</p>
  <p>4. Điện thoại:&nbsp;${
    data?.chuthe_dienthoai ? data?.chuthe_dienthoai : ""
  }&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;Email:&nbsp;${
        data?.chuthe_email ? data?.chuthe_email : ""
      }</p>
  <p>5. Tên người đại diện pháp luật:</p>
  <p>&nbsp; &nbsp;- Họ tên:&nbsp;${
    data?.chuthe_nguoidaidienphapluat ? data?.chuthe_nguoidaidienphapluat : ""
  }</p>
  <p>&nbsp; &nbsp;- Giới tính:&nbsp;${
    data?.chuthe_nguoidaidienphapluat_gioitinh
      ? data?.chuthe_nguoidaidienphapluat_gioitinh
      : ""
  }&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Dân tộc:&nbsp;${
        data?.chuthe_nguoidaidienphapluat_dantoc
          ? data?.chuthe_nguoidaidienphapluat_dantoc
          : ""
      }</p>
  <p>&nbsp; &nbsp;- Địa chỉ thường trú:&nbsp;${
    data?.chuthe_nguoidaidienphapluat_diachi
      ? data?.chuthe_nguoidaidienphapluat_diachi
      : ""
  }</p>
  <p>6. Sản phẩm đăng ký đánh giá:&nbsp;${data?.sanpham_ten}</p>
  <p><strong>II. ĐÁNH GIÁ MỘT SỐ NỘI DUNG CỦA HỒ SƠ ĐĂNG KÝ</strong></p>
  <p style="text-align:justify;">1. Về sử dụng nguyên liệu địa phương: (Nội dung thể hiện rõ mô tả của chủ thể và đánh giá&nbsp;về&nbsp;tình hình sử dụng nguyên liệu thực tế của chủ thể trên địa bàn xã).&nbsp;${
    data?.noidung_nguongoc ? data?.noidung_nguongoc : ""
  }</p>
  <p style="text-align:justify;">2. Về sử dụng lao động địa phương: (Nội dung thể hiện rõ mô&nbsp;tả&nbsp;của chủ thể và đánh giá về tình hình sử dụng thực tế về lao động địa phương của&nbsp;chủ&nbsp;thể trên địa bàn xã).&nbsp;${
    data?.noidung_laodong ? data?.noidung_laodong : ""
  }</p>
  <p style="text-align:justify;">3. Nguồn gốc ý tưởng sản phẩm: (Nhận xét về nguồn gốc sản phẩm (truyền thống, sản phẩm mới) của chủ thể dựa trên thực tế của địa phương).&nbsp;${
    data?.noidung_ytuong ? data?.noidung_ytuong : ""
  }</p>
  <p style="text-align:justify;">4. Bản sắc/trí tuệ địa phương: (Đánh giá về đặc điểm và mức độ thể hiện các giá trị về văn hóa, truyền thông (hình ảnh, câu chuyện,...) trên sản phẩm và hồ sơ của sản phẩm).&nbsp;${
    data?.noidung_bansac ? data?.noidung_bansac : ""
  }</p>
  <p style="text-align:justify;">Ủy ban nhân dân ${
    data?.maphuong_ten
  } đề nghị Ủy ban nhân dân huyện ${
        data?.maquan_ten
      } đánh giá, phân hạng sản phẩm OCOP cho sản phẩm&nbsp;${
        data?.sanpham_ten
      } của&nbsp;${data?.chuthe_ten}.</p>
  <figure class="table" id="tableToSign">
  <table>
  <tbody>
  <tr>
  <td>&nbsp;</td>
  <td>
  <p style="text-align:center;"><strong>TM. UBND ${data?.maphuong_ten
    ?.toString()
    ?.toUpperCase()}</strong></p>
  <p style="text-align:center;">(<i>Ký tên và đóng dấu</i>)</p>
  <p>&nbsp;</p>
  </td></tr>
  </tbody>
  </table>
  </figure>`;
    }
    setPrintContent(body);
  }, [data]);
  const handelClear = () => {
    onClose();
  };
  const handleChangeEditor = (event, editor) => {
    const data = editor.getData();
    setPrintContent(data);
  };

  const handlePrint = () => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = printContent;

    const figureElements = tempDiv.querySelectorAll("figure");
    const lastFigureElement = figureElements[figureElements.length - 1];
    if (lastFigureElement) {
      lastFigureElement.style.float = "inline-end";
    }
    const printWindow = window.open("", "");
    printWindow.document.write(
      "<html><head><title>Đánh giá một số nội dung của Hồ sơ sản phẩm đăng ký tham gia đánh giá sản phẩm OCOP</title>"
    );
    printWindow.document.write(
      "<style>@page { size: A4; margin: 20mm 12mm 20mm 12mm; } body { font-family: 'Times New Roman', Times, serif, Arial, sans-serif; } .tableSign{ display: flex; justify-content: flex-end; } .table{ display: flex; justify-content: center;  }</style>"
    );
    printWindow.document.write("</head><body>");
    printWindow.document.write(tempDiv.innerHTML);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };
  //   console.log(printContent);
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      PaperComponent={PaperComponent}
      onClose={handelClear}
      scroll="paper"
      PaperProps={{
        sx: {
          "@media (min-width: 768px)": {
            minWidth: "40rem",
          },
          height: "100%",
        },
      }}
    >
      {/* Form*/}
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
        }}
      >
        {/* Tiêu đề modal - tham số title */}
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
          In hồ sơ đăng ký
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ overflow: "auto" }}>
          <div className="bg-white">
            <div ref={toolBarRef} />
            <CKEditor
              editor={DecoupledEditor}
              data={printContent ? printContent : ""}
              onReady={(editor) => {
                if (toolBarRef.current) {
                  toolBarRef.current.appendChild(
                    editor.ui.view.toolbar.element
                  );
                }
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "450px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
              onChange={handleChangeEditor}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            variant="contained"
            startIcon={<PrintIcon />}
            size="small"
            onClick={handlePrint}
            sx={{
              color: "#ffffff",
              float: "right",
              mr: 1,
              backgroundColor: "red",
              ":hover": {
                backgroundColor: "red",
              },
            }}
          >
            In
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{
              color: "#ffffff",
              float: "right",
              mr: 1,
              backgroundColor: "gray",
              ":hover": {
                backgroundColor: "gray",
              },
            }}
          >
            Đóng
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default PrintHoSoDangKy;
